export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getAll: state => {
      return state.items
    },
    getItem: state => id => state.items.find(item => item.id == id),
    getByGroup: state => group => state.items.filter(item => item.group_slug == group),
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   boolean wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns promise       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'status',
        api_data_path: 'statuses',
        namespace: 'status'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/status.js